/** Dark-mode design tokens for Geofence screens (mockup palette). */
export const GEOFENCE_DARK = {
  mainBg: '#0B0B0D',
  secondaryBg: '#121216',
  cardBg: '#18181C',
  inputBg: '#202026',
  inputBorder: '#2D2D35',
  divider: '#2A2A2E',
  whiteText: '#F8F8FA',
  primaryText: '#FFFFFF',
  secondaryText: '#B2B2BC',
  placeholder: '#7B7B85',
  disabledText: '#62626B',
  buttonBg: '#F5F5F7',
  buttonText: '#0F0F10',
  buttonPressed: '#E7E7EA',
  buttonDisabled: '#4A4A50',
  iconBg: '#232329',
  switchOff: '#54545D',
  switchThumb: '#FFFFFF',
  enterIconBg: '#163123',
  enterIcon: '#3DDC84',
  enterGreen: '#22C55E',
  exitIconBg: '#351D1F',
  exitIcon: '#FF5B5B',
  exitRed: '#EF4444',
  mapBg: '#17181D',
  mapRoads: '#2D2F35',
  circleBorder: '#FFFFFF',
  circleFill: 'rgba(255,255,255,0.10)',
  pin: '#FFFFFF',
  sliderActive: '#FFFFFF',
  sliderInactive: '#3B3B42',
  sliderThumb: '#FFFFFF',
  shadow: '0 10px 24px rgba(0,0,0,0.35)',
};
